import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../../../../core/constants/base-url";
import {priceLevelConfigCopyResourceType} from "../configs/price-level-config-copy-config";
import {CopyPriceLevelConfigParams} from "../types/price-level-config-copy.types";

@Injectable({
  providedIn: 'root'
})
export class PriceLevelConfigCopyApiService {
  private http: HttpClient = inject(HttpClient);

  public copyPriceLevelConfig(params: CopyPriceLevelConfigParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${priceLevelConfigCopyResourceType.path}/copy`, params);
  }
}
